/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
// import arrowDown from "../../core/assets/images/arrow-down.png";
import useLogout from "../../hooks/useLogout";
import { useActiveView } from "../viewContext";
// import UserContext from "../UserContext";
// import Greeter from "../components/greeter";

const Navbar = ({ name }) => {
  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate("/");
  };


  const { activeView, handleActiveView } = useActiveView();

  // Get user initials from name
  const getInitials = (name) => {
    if (!name) return "U";
    const names = name.trim().split(" ");
    if (names.length === 1) return names[0].charAt(0).toUpperCase();
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white tw-border-b tw-border-black/15">
        <div className="tw-px-3 sm:tw-px-5 tw-w-full tw-max-w-7xl tw-mx-auto tw-flex tw-justify-between">
          <div className="tw-w-fit">
            {/* <Greeter
              username={userData ? userData?.data?.firstname : "Guest"}
            /> */}
          </div>

          <div className="tw-flex tw-items-center tw-gap-2">
            <button className="tw-whitespace-nowrap tw-bg-transparent tw-w-fit tw-px-1 tw-h-10 tw-flex tw-items-center tw-justify-center tw-gap-x-0 tw-rounded-lg tw-border tw-border-black/15 tw-p-1">
              <span
                className={`tw-flex tw-items-center tw-jusify-center tw-font-medium tw-rounded-md tw-w-full tw-h-full tw-px-3 tw-text-sm ${
                  activeView.loan
                    ? "tw-bg-[#F1F4D0] tw-text-[#BEC663]"
                    : "tw-bg-transparent tw-text-black/40"
                }`}
                onClick={() => handleActiveView("loan")}
              >
                Term Assurance
              </span>
              <span
                className={`tw-flex tw-items-center tw-jusify-center tw-font-medium tw-rounded-md tw-w-full tw-h-full tw-px-3 tw-text-sm ${
                  activeView.flexiSave
                    ? "tw-bg-[#F1F4D0] tw-text-[#BEC663]"
                    : "tw-bg-transparent tw-text-black/40"
                }`}
                onClick={() => handleActiveView("flexiSave")}
              >
                IFSP
              </span>
            </button>
            <div className="tw-relative dropdown">
              <button
                className="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-full tw-bg-[#BEC663] tw-text-white tw-font-semibold tw-text-sm tw-cursor-pointer hover:tw-bg-[#a8b056] tw-transition-colors"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title={name}
              >
                {getInitials(name)}
              </button>

              <ul
                className="tw-w-fit dropdown-menu dropdown-menu-end tw-min-w-[200px]"
                aria-labelledby="dropdownMenuLink"
                style={{ right: 0, left: 'auto' }}
              >
                <li className="tw-px-4 tw-py-2 tw-border-b tw-border-black/10">
                  <span className="tw-text-sm tw-font-semibold tw-text-gray-700">
                    Hi, {name}
                  </span>
                </li>
                <li>
                  <a
                    className="tw-text-sm dropdown-item"
                    href={`${process.env.REACT_APP_BASENAME}/profile`}
                  >
                    Profile
                  </a>
                </li>
                <li>
                  <a
                    className="tw-text-sm dropdown-item"
                    href={`${process.env.REACT_APP_BASENAME}/change-password`}
                  >
                    Change Password
                  </a>
                </li>
                <li>
                  <a
                    type="button"
                    onClick={signOut}
                    className="tw-text-sm dropdown-item"
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
